import type { KeyPhrasesSectionType } from "@/lib/requests/types";

export const KeyPhrases = ({
  keyPhrases,
}: {
  keyPhrases: KeyPhrasesSectionType;
}) => (
  <section className="py-12 md:py-20 lg:py-24 overflow-hidden">
    {/* <SimpleSectionTitle title="Key Phrases" subtitle="Speak like a local" /> */}
    <div className="mt-6 max-w-md mx-auto p-10 rounded-full aspect-square flex justify-center items-center text-center relative">
      <ul className="list-inside text-xl text-center">
        {keyPhrases.map(({ phraseInLocalLanguage, translated }, index) => (
          <li key={index}>
            "<strong>{phraseInLocalLanguage}</strong>" - {translated}
          </li>
        ))}
      </ul>
      <Outline className="absolute inset-0 scale-125 w-full h-full [&_path]:fill-orange-500" />
    </div>
  </section>
);

const Outline = ({ className }: { className?: string }) => (
  <svg
    width="197"
    height="166"
    viewBox="0 0 197 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M142.944 18.5435C152.501 19.0329 160.097 23.863 167.693 29.2866C192.605 47.0973 200.937 74.7316 183.866 101.887C157.32 143.999 95.4879 171.56 47.5416 158.84C36.9232 156.037 22.5474 153.566 12.0107 139.877C2.20905 127.148 2.61745 112.016 7.10987 98.0073C11.684 83.6438 20.5054 70.4242 27.5299 61.9266C58.2417 24.8517 119.747 -8.84446 175.371 8.91986C176.515 9.26214 177.658 8.67352 177.985 7.60522C178.312 6.53692 177.74 5.39139 176.678 5.04911C119.42 -13.2331 55.9543 21.1866 24.3441 59.3421C15.6043 69.9381 4.1697 87.626 0.902488 105.927C-1.30288 118.435 0.248727 131.221 8.74347 142.344C19.9337 156.926 35.208 159.782 46.4799 162.768C95.9781 175.905 159.933 147.538 187.296 104.046C205.674 74.8584 196.853 45.1282 170.062 25.9842C161.894 20.0996 153.562 15.0142 143.189 14.4841C142.045 14.4264 141.065 15.289 141.065 16.4093C140.984 17.5297 141.882 18.4858 142.944 18.5435Z"
      fill="black"
    />
  </svg>
);
